export const DAILY_RENT_SEARCH_PATH = '/snyat-kvartiru-posutochno/';
